const fitChartSize = (size,defalteWidth = 1920) => {
  let clientWidth; 
  let ua = navigator.userAgent; 
  if(ua.indexOf('Html5Plus') > -1){//h5+App  
    clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
  }else{//浏览器访问
    if(window.innerWidth<800){
      if (window.innerWidth === window.DEVICEWIDTH) return 0;    
      clientWidth = window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;   
    }  else { 
      clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;   
    } 
  }   
  if (!clientWidth) return size;
  let scale = (clientWidth / defalteWidth); 
  return Number((size*scale).toFixed(3));
}
export default fitChartSize


// WEBPACK FOOTER //
// ./src/common/js/echartFontSize.js